module.exports = __webpack_public_path__ + "img/reporting_updates.a8649bd6.png";